import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/HomeWorkOrders'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class HomeWorkOrdersStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "HomeWorkOrdersStore",
			variables: false,
		})
	}
}

export async function load_HomeWorkOrders(params) {
  await initClient()

	const store = new HomeWorkOrdersStore()

	await store.fetch(params)

	return {
		HomeWorkOrders: store,
	}
}
